module.exports = __webpack_public_path__ + "img/function-4.2036ed95.png";